import {FeatureGatePageWrapper} from '../../limits/feature-gates/feature-gate-page-wrapper';

export function SchedulerFeatureGatePage() {
    return (
        <FeatureGatePageWrapper
            header='Book and manage meetings with leads and customers '
            subHeader='Nutshell Scheduler allows you to plan, schedule and manage meetings with prospects and clients, all from inside Nutshell.'
            bullets={[
                'Collect bookings via shared link or web form.',
                'Include Zoom, Google Meet, or Microsoft Teams links in the invitation.',
                'Gather information about attendees with a Nutshell form.',
                'Automatically create new leads with each booking.',
            ]}
            feature='scheduler'
        />
    );
}
